import React, { useState } from "react";
import { Icon } from "@iconify/react";

const TicketSidebar = ({ tickets, activeTicket, setActiveTicket }) => {
  const [filters, setFilters] = useState({ search: "", status: "all" });

  const statusBadge = (status) => {
    switch (status) {
      case "open":
        return "bg-success";
      case "pending":
        return "bg-warning text-dark";
      case "closed":
        return "bg-secondary";
      default:
        return "bg-light text-dark";
    }
  };

  const filteredTickets = tickets.filter((t) => {
    const matchesSearch =
      t.ticket_id?.toLowerCase().includes(filters.search.toLowerCase()) ||
      t.subject?.toLowerCase().includes(filters.search.toLowerCase());
    const matchesStatus =
      filters.status === "all" || t.status === filters.status;
    return matchesSearch && matchesStatus;
  });

  return (
    <>
      {/* Filters */}
      <div className="p-3 border-bottom">
        <div className="chat-search mb-2 d-flex align-items-center">
          <span className="me-2">
            <Icon icon="iconoir:search" />
          </span>
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search tickets..."
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          />
        </div>
        <select
          className="form-select form-select-sm"
          value={filters.status}
          onChange={(e) => setFilters({ ...filters, status: e.target.value })}
        >
          <option value="all">All Status</option>
          <option value="open">Open</option>
          <option value="pending">Pending</option>
          <option value="closed">Closed</option>
        </select>
      </div>

      {/* Ticket List */}
      <div className="chat-all-list">
        {filteredTickets.length === 0 ? (
          <div className="p-3 text-center text-muted">No tickets found</div>
        ) : (
          filteredTickets.map((ticket) => (
            <div
              key={ticket._id}
              className={`chat-sidebar-single ${
                activeTicket?._id === ticket._id ? "active bg-light" : ""
              } ${ticket.status === "closed" ? "opacity-75" : ""}`}
              style={{ cursor: "pointer", flexWrap: "unset" }}
              onClick={() => setActiveTicket(ticket)}
            >
              <img
                src={ticket.appRefId?.appImage}
                alt={ticket.appRefId?.appName}
                className="me-2 rounded"
                style={{ width: "50px", height: "50px", objectFit: "cover" }}
              />
              <div className="flex-grow-1">
                <div className="fw-semibold small">
                  {ticket.appRefId?.appName}
                </div>
                <b style={{ fontSize: "10px" }}>#{ticket.ticket_id}</b>
                <div className="text-muted small">{ticket.subject}</div>
              </div>
              <span className={`badge ${statusBadge(ticket.status)}`}>
                {ticket.status}
              </span>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default TicketSidebar;
